import Svg, { G, Line, Path, Rect } from 'react-native-svg'

//FIXME: update with real SVG's
export const NoSettlement = () => {
  return (
    <Svg width="195.614" height="121.308" viewBox="0 0 195.614 121.308">
      <G id="No_Settlements" data-name="No Settlements" transform="translate(-914.634 -1059.702)">
        <G id="Group_1361" data-name="Group 1361" transform="translate(914.634 1108.789)">
          <G id="Group_872" data-name="Group 872" transform="translate(0 0)">
            <G
              id="Rectangle_995"
              data-name="Rectangle 995"
              transform="translate(180.514 71.095) rotate(90)"
              fill="none"
              stroke="#214796"
              strokeWidth="4">
              <Rect id="fill" width="1" height="159.939" rx="0.5" stroke="none" />
              <Path
                d="M0,2h1M2,0v159.93882751464844M1,157.93882751464844h-1M-1,159.93882751464844v-159.93882751464844"
                fill="none"
                clipPath="url(#clip)"
              />
            </G>
            <G
              id="Rectangle_1003"
              data-name="Rectangle 1003"
              transform="translate(195.614 71.095) rotate(90)"
              fill="none"
              stroke="#214796"
              strokeWidth="2">
              <Rect id="fill-2" width="1" height="8.797" rx="0.5" stroke="none" />
              <Path
                d="M0,1h1M1,0v8.797151565551758M1,7.797151565551758h-1M0,8.797151565551758v-8.797151565551758"
                fill="none"
                clipPath="url(#clip-2)"
              />
            </G>
            <G
              id="Rectangle_998"
              data-name="Rectangle 998"
              transform="translate(17.592 71.095) rotate(90)"
              fill="none"
              stroke="#214796"
              strokeWidth="2">
              <Rect id="fill-3" width="1" height="9.151" rx="0.5" stroke="none" />
              <Path
                d="M0,1h1M1,0v9.150984764099121M1,8.150984764099121h-1M0,9.150984764099121v-9.150984764099121"
                fill="none"
                clipPath="url(#clip-3)"
              />
            </G>
            <G
              id="Rectangle_999"
              data-name="Rectangle 999"
              transform="translate(5.458 71.095) rotate(90)"
              fill="none"
              stroke="#214796"
              strokeWidth="2">
              <Rect id="fill-4" width="1" height="5.458" rx="0.5" stroke="none" />
              <Path
                d="M0,1h1M1,0v5.45805549621582M1,4.45805549621582h-1M0,5.45805549621582v-5.45805549621582"
                fill="none"
                clipPath="url(#clip-4)"
              />
            </G>
          </G>
        </G>
        <G id="Group_2565" data-name="Group 2565" transform="translate(978.807 1060.202)">
          <Rect
            id="Rectangle_302"
            data-name="Rectangle 302"
            width="68.223"
            height="115.82"
            rx="4"
            transform="translate(0 0)"
            fill="#fff"
          />
          <Rect
            id="Rectangle_1004"
            data-name="Rectangle 1004"
            width="68.223"
            height="120.308"
            rx="8"
            transform="translate(0.421 0)"
            fill="rgba(33,71,150,0.08)"
            stroke="#2a4e9a"
            strokeWidth="1"
          />
          <Rect
            id="Rectangle_1005"
            data-name="Rectangle 1005"
            width="11.968"
            height="11.968"
            rx="5.984"
            transform="translate(28.843 98.264)"
            fill="rgba(33,71,150,0.08)"
            stroke="#2a4e9a"
            strokeWidth="1"
          />
          <G id="Group_2931" data-name="Group 2931" transform="translate(-5.173 6.586)">
            <G id="Group_2589" data-name="Group 2589" transform="translate(0)">
              <G
                id="Rectangle_1476"
                data-name="Rectangle 1476"
                transform="translate(97.836 25.213) rotate(90)"
                fill="#fff"
                stroke="#2a4e9a"
                strokeWidth="1">
                <Rect width="38.706" height="117.836" rx="4" stroke="none" />
                <Rect x="0.5" y="0.5" width="37.706" height="116.836" rx="3.5" fill="none" />
              </G>
              <G
                id="Rectangle_1477"
                data-name="Rectangle 1477"
                transform="translate(97.836 42.213) rotate(90)"
                fill="#fff"
                stroke="#2a4e9a"
                strokeWidth="1">
                <Rect width="38.706" height="117.836" rx="4" stroke="none" />
                <Rect x="0.5" y="0.5" width="37.706" height="116.836" rx="3.5" fill="none" />
              </G>
              <G id="Group_2934" data-name="Group 2934">
                <G
                  id="Rectangle_993"
                  data-name="Rectangle 993"
                  transform="translate(105.836 33.702) rotate(90)"
                  fill="#fff"
                  stroke="#2a4e9a"
                  strokeWidth="1">
                  <Rect width="38.706" height="133.836" rx="4" stroke="none" />
                  <Rect x="0.5" y="0.5" width="37.706" height="132.836" rx="3.5" fill="none" />
                </G>
                <G id="Group_2933" data-name="Group 2933" transform="translate(0 2.5)">
                  <Line
                    id="Line_38"
                    data-name="Line 38"
                    x2="44"
                    transform="translate(-13.167 45.202)"
                    fill="none"
                    stroke="#2a4e9a"
                    strokeLinecap="round"
                    strokeWidth="1"
                  />
                  <Line
                    id="Line_39"
                    data-name="Line 39"
                    x2="14"
                    transform="translate(-13.167 56.202)"
                    fill="none"
                    stroke="#2a4e9a"
                    strokeLinecap="round"
                    strokeWidth="1"
                  />
                  <Line
                    id="Line_40"
                    data-name="Line 40"
                    x2="14"
                    transform="translate(4.833 56.202)"
                    fill="none"
                    stroke="#2a4e9a"
                    strokeLinecap="round"
                    strokeWidth="1"
                  />
                </G>
                <Path
                  id="Path_422"
                  data-name="Path 422"
                  d="M23.792-5.838,21.937-7.82a.865.865,0,0,0-.28-.191.85.85,0,0,0-.33-.064.788.788,0,0,0-.3.064.776.776,0,0,0-.254.165L18.786-5.99a.916.916,0,0,0-.191.267.76.76,0,0,0-.064.318.782.782,0,0,0,.241.572.782.782,0,0,0,.572.241.849.849,0,0,0,.292-.051.652.652,0,0,0,.241-.152l.559-.508a7.329,7.329,0,0,1-.839,2.77A7.74,7.74,0,0,1,17.884-.285a7.88,7.88,0,0,1-2.4,1.487,7.416,7.416,0,0,1-2.872.559,7.651,7.651,0,0,1-2.16-.3A8.037,8.037,0,0,1,8.544.6,8.824,8.824,0,0,1,6.917-.679,8.5,8.5,0,0,1,5.7-2.356a1,1,0,0,0-.318-.356.74.74,0,0,0-.419-.127.77.77,0,0,0-.585.241.8.8,0,0,0-.229.572.836.836,0,0,0,.025.2q.025.1.051.178A9.636,9.636,0,0,0,5.672.363,9.291,9.291,0,0,0,7.553,1.939,9.484,9.484,0,0,0,9.815,2.981a8.709,8.709,0,0,0,2.491.407h.33a9.355,9.355,0,0,0,3.507-.661A9.831,9.831,0,0,0,19.053.884a9.626,9.626,0,0,0,2.071-2.757,9.223,9.223,0,0,0,.94-3.38l.559.534a.631.631,0,0,0,.254.191.85.85,0,0,0,.33.064.8.8,0,0,0,.572-.229.77.77,0,0,0,.241-.585.7.7,0,0,0-.064-.292A1.264,1.264,0,0,0,23.792-5.838ZM6.485-6.931a.865.865,0,0,0,.191-.28.788.788,0,0,0,.064-.3A.77.77,0,0,0,6.5-8.1a.8.8,0,0,0-.572-.229.959.959,0,0,0-.3.051.638.638,0,0,0-.254.152l-.534.508a7.846,7.846,0,0,1,.813-2.8,8.393,8.393,0,0,1,1.728-2.224,8.12,8.12,0,0,1,2.389-1.512,7.923,7.923,0,0,1,2.9-.534,7.651,7.651,0,0,1,2.16.3,7.922,7.922,0,0,1,1.931.851,8.291,8.291,0,0,1,1.627,1.309,8.192,8.192,0,0,1,1.22,1.7,1,1,0,0,0,.318.356.74.74,0,0,0,.419.127.782.782,0,0,0,.572-.241.782.782,0,0,0,.241-.572.835.835,0,0,0-.025-.2.565.565,0,0,0-.076-.178,10.068,10.068,0,0,0-1.474-2.084,9.6,9.6,0,0,0-1.97-1.6,10.1,10.1,0,0,0-2.325-1.042,9.662,9.662,0,0,0-2.618-.356,9.355,9.355,0,0,0-3.507.661,10,10,0,0,0-2.923,1.843,9.25,9.25,0,0,0-2.059,2.732,8.974,8.974,0,0,0-.966,3.406L2.648-8.2a.75.75,0,0,0-.254-.2.728.728,0,0,0-.33-.076.77.77,0,0,0-.585.241.8.8,0,0,0-.229.572.76.76,0,0,0,.064.318.814.814,0,0,0,.165.241L3.334-5.126a.865.865,0,0,0,.28.191.85.85,0,0,0,.33.064.849.849,0,0,0,.292-.051A.942.942,0,0,0,4.5-5.075ZM15.177-9.04h0a.782.782,0,0,0,.572-.241.782.782,0,0,0,.241-.572V-9.9a.811.811,0,0,0-.267-.534.8.8,0,0,0-.572-.229H10.094a.8.8,0,0,0-.47.152.753.753,0,0,0-.292.381,1.175,1.175,0,0,0-.038.14.714.714,0,0,0-.013.14.782.782,0,0,0,.241.572.782.782,0,0,0,.572.241h1.5a1.448,1.448,0,0,1,.737.191,1.5,1.5,0,0,1,.534.521H10.145a.829.829,0,0,0-.572.216.787.787,0,0,0-.267.546v.051a.782.782,0,0,0,.241.572.782.782,0,0,0,.572.241h2.745a1.5,1.5,0,0,1-.534.521,1.448,1.448,0,0,1-.737.191H10.73a.869.869,0,0,0-.369.076.722.722,0,0,0-.267.2,1.011,1.011,0,0,0-.152.254.746.746,0,0,0-.051.28.849.849,0,0,0,.051.292.652.652,0,0,0,.152.241L12.407-1.95a1.073,1.073,0,0,0,.28.2.786.786,0,0,0,.356.076.746.746,0,0,0,.28-.051,1.778,1.778,0,0,0,.254-.127H13.55a.877.877,0,0,0,.229-.28.786.786,0,0,0,.076-.356.645.645,0,0,0-.064-.267,1.294,1.294,0,0,0-.14-.241L12.381-4.466a3.237,3.237,0,0,0,1.41-.813,3.094,3.094,0,0,0,.826-1.4l.508-.025h.025a.829.829,0,0,0,.572-.216.787.787,0,0,0,.267-.546v-.051a.782.782,0,0,0-.241-.572.782.782,0,0,0-.572-.241h-.534a2.515,2.515,0,0,0-.127-.381q-.076-.178-.152-.33Z"
                  transform="translate(67.237 59.511)"
                  fill="#2a4e9a"
                  stroke="#fff"
                  strokeWidth="0.5"
                />
              </G>
            </G>
          </G>
        </G>
      </G>
    </Svg>
  )
}
